//域名
const domain = window.location.host + "/api";

//端口
const port = null;

//路径
const root = window.location.protocol + "//" + domain + (port ? (":" + port) : "");

//接口
const api = {};

export default Object.assign(
  {
    $base: {
      domain: domain,
      port: port,
      root: root,
    },
    file: {
      upload: `${root}/common/upload`,
      downloadImg: `${root}/commonFile/download?code=`,
      uploadEditor: `${root}/common/uploadEditor`
    },
    dict: {
      detail: `${root}/common/dictList`,
      list: `${root}/dictType/allDict`,
    },

    common: {
      hardwareExport: `${root}/common/hardwareExport`,
      iThardwareExport: `${root}/common/iThardwareExport`,
      smartUnitExport: `${root}/common/smartUnitExport`,
      exportOnOffSet: `${root}/common/exportOnOffSet`,
      exportFeelWeightAutoOn: `${root}/common/exportFeelWeightAutoOn`,
      exportBrightSet: `${root}/common/exportBrightSet`,
      exportTemperatureSet: `${root}/common/exportTemperatureSet`,
      exportButtonSound: `${root}/common/exportButtonSound`,
      exportCookbookOperateSet: `${root}/common/exportCookbookOperateSet`,
      exportRefactorySet: `${root}/common/exportRefactorySet`,
      exportPrecisionAdjust: `${root}/common/exportPrecisionAdjust`,
      exportPrecisionSet: `${root}/common/exportPrecisionSet`,
      exportButtonFunction: `${root}/common/exportButtonFunction`,
      exportHardwareName: `${root}/common/exportHardwareName`,
      exportProductModel: `${root}/common/exportProductModel`,
      exportProductBrand: `${root}/common/exportProductBrand`,
      exportWeightRule: `${root}/common/exportWeightRule`,
      exportSuitTemperature: `${root}/common/exportSuitTemperature`,
      exportMasterChip: `${root}/common/exportMasterChip`,
      exportBluetoothVersion: `${root}/common/exportBluetoothVersion`,
      exportSensor: `${root}/common/exportSensor`,
      exportLiquidCrystal: `${root}/common/exportLiquidCrystal`,
      exportPowerWay: `${root}/common/exportPowerWay`,
      exportGraphModel: `${root}/common/exportGraphModel`,

    },

    anUser: {
      list: `${root}/anUser/list`,
      detail: `${root}/anUser/detail`,
      delete: `${root}/anUser/delete`,
      batchDelete: `${root}/anUser/batchDelete`,
      update: `${root}/anUser/update`,
      updateStatus: `${root}/anUser/updateStatus`,
      addVir: `${root}/anUser/addVir`,
      batchUpdateStatus: `${root}/anUser/batchUpdateStatus`,
      resetPwd: `${root}/anUser/resetPwd`,
      exportVirUser: `${root}/anUser/exportVirUser`
    },

    fans: {
      list: `${root}/fans/list`
    },

    dynamics: {
      list: `${root}/dynamics/list`,
      delete: `${root}/dynamics/delete`,
      batchDelete: `${root}/dynamics/batchDelete`,
      batchUpdate: `${root}/dynamics/batchUpdate`,
      updateStatus: `${root}/dynamics/updateStatus`,
      detail: `${root}/dynamics/detail`,
      update: `${root}/dynamics/update`,
    },

    dynamicsComment: {
      list: `${root}/dynamicsComment/list`,
      delete: `${root}/dynamicsComment/delete`,
      batchDelete: `${root}/dynamicsComment/batchDelete`,
    },

    cookbookComment: {
      list: `${root}/cookbookComment/list`,
      delete: `${root}/cookbookComment/delete`,
      batchDelete: `${root}/cookbookComment/batchDelete`,
    },

    cookbook: {
      list: `${root}/cookbook/list`,
      detail: `${root}/cookbook/detail`,
      delete: `${root}/cookbook/delete`,
      batchDelete: `${root}/cookbook/batchDelete`,
      update: `${root}/cookbook/update`,
      audit: `${root}/cookbook/audit`,
      updateStatus: `${root}/cookbook/updateStatus`,
      batchDown: `${root}/cookbook/batchDown`,
      listMy: `${root}/cookbook/listMy`,
      countData: `${root}/cookbook/countData`,
      listByType: `${root}/cookbook/listByType`,
      listSame: `${root}/cookbook/listSame`,
      batchAudit: `${root}/cookbook/batchAudit`
    },

    searchTypeSort: {
      list: `${root}/searchTypeSort/list`,
      detail: `${root}/searchTypeSort/detail`,
      delete: `${root}/searchTypeSort/delete`,
      batchDelete: `${root}/searchTypeSort/batchDelete`,
      update: `${root}/searchTypeSort/update`,
      save: `${root}/searchTypeSort/save`,
    },

    foodPhysioSort: {
      list: `${root}/foodPhysioSort/list`,
      listType: `${root}/foodPhysioSort/listType`,
      save: `${root}/foodPhysioSort/save`,
      delete: `${root}/foodPhysioSort/delete`,
      batchDelete: `${root}/foodPhysioSort/batchDelete`,
    },

    cookbookHandleRecord: {
      list: `${root}/cookbookHandleRecord/list`
    },

    cookbookSort: {
      list: `${root}/cookbookSort/list`,
      detail: `${root}/cookbookSort/detail`,
      delete: `${root}/cookbookSort/delete`,
      batchDelete: `${root}/cookbookSort/batchDelete`,
      update: `${root}/cookbookSort/update`,
      save: `${root}/cookbookSort/save`,
      listOne: `${root}/cookbookSort/listOne`,
      saveOne: `${root}/cookbookSort/saveOne`,
    },

    cookToolSort: {
      list: `${root}/cookToolSort/list`,
      save: `${root}/cookToolSort/save`,
      delete: `${root}/cookToolSort/delete`,
      batchDelete: `${root}/cookToolSort/batchDelete`,
    },

    tasteSort: {
      list: `${root}/tasteSort/list`,
      save: `${root}/tasteSort/save`,
      delete: `${root}/tasteSort/delete`,
      batchDelete: `${root}/tasteSort/batchDelete`,
    },

    cookDifficultySort: {
      list: `${root}/cookDifficultySort/list`,
      save: `${root}/cookDifficultySort/save`,
      delete: `${root}/cookDifficultySort/delete`,
      batchDelete: `${root}/cookDifficultySort/batchDelete`,
    },

    cookDurationSort: {
      list: `${root}/cookDurationSort/list`,
      save: `${root}/cookDurationSort/save`,
      delete: `${root}/cookDurationSort/delete`,
      batchDelete: `${root}/cookDurationSort/batchDelete`,
    },

    moreSort: {
      list: `${root}/moreSort/list`,
      save: `${root}/moreSort/save`,
      delete: `${root}/moreSort/delete`,
      batchDelete: `${root}/moreSort/batchDelete`,
    },

    cookStep: {
      list: `${root}/cookStep/list`
    },

    foodSort: {
      list: `${root}/foodSort/list`,
      save: `${root}/foodSort/save`,
      delete: `${root}/foodSort/delete`,
      batchDelete: `${root}/foodSort/batchDelete`,
      listSecond: `${root}/foodSort/listSecond`,
      detail: `${root}/foodSort/detail`,
      saveSecond: `${root}/foodSort/saveSecond`,
      listUser: `${root}/foodSort/listUser`,
      listAiFood: `${root}/foodSort/listAiFood`,
    },

    elementSort: {
      list: `${root}/elementSort/list`,
      save: `${root}/elementSort/save`,
      delete: `${root}/elementSort/delete`,
      batchDelete: `${root}/elementSort/batchDelete`,
      addByElementCode: `${root}/elementSort/addByElementCode`,
    },

    foodElement: {
      list: `${root}/foodElement/list`,
      save: `${root}/foodElement/save`,
      delete: `${root}/foodElement/delete`,
      batchDelete: `${root}/foodElement/batchDelete`,
    },

    topicSort: {
      list: `${root}/topicSort/list`,
      delete: `${root}/topicSort/delete`,
      batchDelete: `${root}/topicSort/batchDelete`,
      save: `${root}/topicSort/save`,
      listSecond: `${root}/topicSort/listSecond`,
      saveSecond: `${root}/topicSort/saveSecond`,
      detail: `${root}/topicSort/detail`,
    },

    vipSetmeal: {
      list: `${root}/vipSetmeal/list`,
      delete: `${root}/vipSetmeal/delete`,
      batchDelete: `${root}/vipSetmeal/batchDelete`,
      add: `${root}/vipSetmeal/add`,
      update: `${root}/vipSetmeal/update`,
    },

    vipLevel: {
      list: `${root}/vipLevel/list`,
      delete: `${root}/vipLevel/delete`,
      batchDelete: `${root}/vipLevel/batchDelete`,
      add: `${root}/vipLevel/add`,
      detail: `${root}/vipLevel/detail`,
      update: `${root}/vipLevel/update`,
    },

    vipExpireRule: {
      list: `${root}/vipExpireRule/list`,
      update: `${root}/vipExpireRule/update`,
      updateStatus: `${root}/vipExpireRule/updateStatus`,
    },

    userVipLevel: {
      list: `${root}/userVipLevel/list`,
      delete: `${root}/userVipLevel/delete`,
      batchDelete: `${root}/userVipLevel/batchDelete`,
      add: `${root}/userVipLevel/add`,
      update: `${root}/userVipLevel/update`,
    },

    releaseVipLevel: {
      list: `${root}/releaseVipLevel/list`,
      delete: `${root}/releaseVipLevel/delete`,
      batchDelete: `${root}/releaseVipLevel/batchDelete`,
      add: `${root}/releaseVipLevel/add`,
      update: `${root}/releaseVipLevel/update`,
    },

    releaseVipIntegralRule: {
      list: `${root}/releaseVipIntegralRule/list`,
      delete: `${root}/releaseVipIntegralRule/delete`,
      batchDelete: `${root}/releaseVipIntegralRule/batchDelete`,
      add: `${root}/releaseVipIntegralRule/add`,
      update: `${root}/releaseVipIntegralRule/update`,
    },


    userVipIntegralRule: {
      list: `${root}/userVipIntegralRule/list`,
      delete: `${root}/userVipIntegralRule/delete`,
      batchDelete: `${root}/userVipIntegralRule/batchDelete`, add: `${root}/userVipIntegralRule/add`,
      update: `${root}/userVipIntegralRule/update`,
    },

    userIntegralRecord: {
      list: `${root}/userIntegralRecord/list`,
      delete: `${root}/userIntegralRecord/delete`,
      batchDelete: `${root}/userIntegralRecord/batchDelete`,
    },

    activateCode: {
      list: `${root}/activateCode/list`,
      delete: `${root}/activateCode/delete`,
      batchDelete: `${root}/activateCode/batchDelete`,
      add: `${root}/activateCode/add`,
      update: `${root}/activateCode/update`,
      updateStatus: `${root}/activateCode/updateStatus`,
      detail: `${root}/activateCode/detail`,
      export: `${root}/activateCode/export`
    },

    activateCodeRecord: {
      list: `${root}/activateCodeRecord/list`,
      delete: `${root}/activateCodeRecord/delete`,
      batchDelete: `${root}/activateCodeRecord/batchDelete`,
      add: `${root}/activateCodeRecord/add`,
      update: `${root}/activateCodeRecord/update`,
      batchUpdateStatus: `${root}/activateCodeRecord/batchUpdateStatus`,
      updateStatus: `${root}/activateCodeRecord/updateStatus`,
      listStatus: `${root}/activateCodeRecord/listStatus`,
      export: `${root}/activateCodeRecord/export`
    },

    banner: {
      list: `${root}/banner/list`,
      delete: `${root}/banner/delete`,
      batchDelete: `${root}/banner/batchDelete`,
      add: `${root}/banner/add`,
      update: `${root}/banner/update`,
      updateStatus: `${root}/banner/updateStatus`,
    },

    notice: {
      list: `${root}/notice/list`,
      delete: `${root}/notice/delete`,
      batchDelete: `${root}/notice/batchDelete`,
      add: `${root}/notice/add`,
      update: `${root}/notice/update`,
      updateStatus: `${root}/notice/updateStatus`,
      detail: `${root}/notice/detail`,
      saveSort: `${root}/notice/saveSort`,
    },

    questionSort: {
      list: `${root}/questionSort/list`,
      delete: `${root}/questionSort/delete`,
      batchDelete: `${root}/questionSort/batchDelete`,
      save: `${root}/questionSort/save`,
      check: `${root}/questionSort/check`,
      detail: `${root}/questionSort/detail`,
      updateQuestion: `${root}/questionSort/updateQuestion`,
    },

    suggestion: {
      list: `${root}/suggestion/list`,
      delete: `${root}/suggestion/delete`,
      batchDelete: `${root}/suggestion/batchDelete`,
      detail: `${root}/suggestion/detail`,
      reply: `${root}/suggestion/reply`,
    },

    report: {
      list: `${root}/report/list`,
      delete: `${root}/report/delete`,
      batchDelete: `${root}/report/batchDelete`,
      updateStatus: `${root}/report/updateStatus`,
    },

    installPackage: {
      list: `${root}/installPackage/list`,
      delete: `${root}/installPackage/delete`,
      batchDelete: `${root}/installPackage/batchDelete`,
      updateStatus: `${root}/installPackage/updateStatus`,
      add: `${root}/installPackage/add`,
    },

    richText: {
      list: `${root}/richText/list`,
      add: `${root}/richText/add`,
      delete: `${root}/richText/delete`,
      batchDelete: `${root}/richText/batchDelete`,
      update: `${root}/richText/update`,
      detail: `${root}/richText/detail`,
    },

    reward: {
      list: `${root}/reward/list`,
      add: `${root}/reward/add`,
      update: `${root}/reward/update`,
      delete: `${root}/reward/delete`,
      batchDelete: `${root}/reward/batchDelete`,
      detail: `${root}/reward/detail`,
    },

    onOffSet: {
      list: `${root}/onOffSet/list`,
      delete: `${root}/onOffSet/delete`,
      batchDelete: `${root}/onOffSet/batchDelete`,
      add: `${root}/onOffSet/add`,
      update: `${root}/onOffSet/update`,
    },

    feelWeightAutoOn: {
      list: `${root}/feelWeightAutoOn/list`,
      delete: `${root}/feelWeightAutoOn/delete`,
      batchDelete: `${root}/feelWeightAutoOn/batchDelete`,
      add: `${root}/feelWeightAutoOn/add`,
      update: `${root}/feelWeightAutoOn/update`,
    },

    brightSet: {
      list: `${root}/brightSet/list`,
      delete: `${root}/brightSet/delete`,
      batchDelete: `${root}/brightSet/batchDelete`,
      add: `${root}/brightSet/add`,
      update: `${root}/brightSet/update`,
    },

    temperatureSet: {
      list: `${root}/temperatureSet/list`,
      delete: `${root}/temperatureSet/delete`,
      batchDelete: `${root}/temperatureSet/batchDelete`,
      add: `${root}/temperatureSet/add`,
      update: `${root}/temperatureSet/update`,
    },

    buttonSound: {
      list: `${root}/buttonSound/list`,
      delete: `${root}/buttonSound/delete`,
      batchDelete: `${root}/buttonSound/batchDelete`,
      add: `${root}/buttonSound/add`,
      update: `${root}/buttonSound/update`,
    },

    cookbookOperateSet: {
      list: `${root}/cookbookOperateSet/list`,
      delete: `${root}/cookbookOperateSet/delete`,
      batchDelete: `${root}/cookbookOperateSet/batchDelete`,
      add: `${root}/cookbookOperateSet/add`,
      update: `${root}/cookbookOperateSet/update`,
    },

    refactorySet: {
      list: `${root}/refactorySet/list`,
      delete: `${root}/refactorySet/delete`,
      batchDelete: `${root}/refactorySet/batchDelete`,
      add: `${root}/refactorySet/add`,
      update: `${root}/refactorySet/update`,
    },

    precisionAdjust: {
      list: `${root}/precisionAdjust/list`,
      delete: `${root}/precisionAdjust/delete`,
      batchDelete: `${root}/precisionAdjust/batchDelete`,
      add: `${root}/precisionAdjust/add`,
      update: `${root}/precisionAdjust/update`,
    },

    precisionSet: {
      list: `${root}/precisionSet/list`,
      delete: `${root}/precisionSet/delete`,
      batchDelete: `${root}/precisionSet/batchDelete`,
      add: `${root}/precisionSet/add`,
      update: `${root}/precisionSet/update`,
    },

    buttonFunction: {
      list: `${root}/buttonFunction/list`,
      delete: `${root}/buttonFunction/delete`,
      batchDelete: `${root}/buttonFunction/batchDelete`,
      add: `${root}/buttonFunction/add`,
      update: `${root}/buttonFunction/update`,
    },

    hardwareName: {
      list: `${root}/hardwareName/list`,
      delete: `${root}/hardwareName/delete`,
      batchDelete: `${root}/hardwareName/batchDelete`,
      add: `${root}/hardwareName/add`,
      update: `${root}/hardwareName/update`,
    },

    productModel: {
      list: `${root}/productModel/list`,
      delete: `${root}/productModel/delete`,
      batchDelete: `${root}/productModel/batchDelete`,
      add: `${root}/productModel/add`,
      update: `${root}/productModel/update`,
    },

    productBrand: {
      list: `${root}/productBrand/list`,
      delete: `${root}/productBrand/delete`,
      batchDelete: `${root}/productBrand/batchDelete`,
      add: `${root}/productBrand/add`,
      update: `${root}/productBrand/update`,
    },

    weightRule: {
      list: `${root}/weightRule/list`,
      delete: `${root}/weightRule/delete`,
      batchDelete: `${root}/weightRule/batchDelete`,
      add: `${root}/weightRule/add`,
      update: `${root}/weightRule/update`,
    },

    suitTemperature: {
      list: `${root}/suitTemperature/list`,
      delete: `${root}/suitTemperature/delete`,
      batchDelete: `${root}/suitTemperature/batchDelete`,
      add: `${root}/suitTemperature/add`,
      update: `${root}/suitTemperature/update`,
    },

    masterChip: {
      list: `${root}/masterChip/list`,
      delete: `${root}/masterChip/delete`,
      batchDelete: `${root}/masterChip/batchDelete`,
      add: `${root}/masterChip/add`,
      update: `${root}/masterChip/update`,
    },

    bluetoothVersion: {
      list: `${root}/bluetoothVersion/list`,
      delete: `${root}/bluetoothVersion/delete`,
      batchDelete: `${root}/bluetoothVersion/batchDelete`,
      add: `${root}/bluetoothVersion/add`,
      update: `${root}/bluetoothVersion/update`,
    },

    sensor: {
      list: `${root}/sensor/list`,
      delete: `${root}/sensor/delete`,
      batchDelete: `${root}/sensor/batchDelete`,
      add: `${root}/sensor/add`,
      update: `${root}/sensor/update`,
    },

    liquidCrystal: {
      list: `${root}/liquidCrystal/list`,
      delete: `${root}/liquidCrystal/delete`,
      batchDelete: `${root}/liquidCrystal/batchDelete`,
      add: `${root}/liquidCrystal/add`,
      update: `${root}/liquidCrystal/update`,
    },

    powerWay: {
      list: `${root}/powerWay/list`,
      delete: `${root}/powerWay/delete`,
      batchDelete: `${root}/powerWay/batchDelete`,
      add: `${root}/powerWay/add`,
      update: `${root}/powerWay/update`,
    },


    userVipRecord: {
      list: `${root}/userVipRecord/list`
    },

    boiledRiceModel: {
      list: `${root}/boiledRiceModel/list`,
      delete: `${root}/boiledRiceModel/delete`,
      batchDelete: `${root}/boiledRiceModel/batchDelete`,
      add: `${root}/boiledRiceModel/add`,
      update: `${root}/boiledRiceModel/update`,
      updateStatus: `${root}/boiledRiceModel/updateStatus`,
    },

    riceRwrTips: {
      list: `${root}/riceRwrTips/list`,
      detail: `${root}/riceRwrTips/detail`,
      update: `${root}/riceRwrTips/update`,
    },

    graphModel: {
      list: `${root}/graphModel/list`,
      delete: `${root}/graphModel/delete`,
      batchDelete: `${root}/graphModel/batchDelete`,
      add: `${root}/graphModel/add`,
      update: `${root}/graphModel/update`,
    },

    rangeSoundSet: {
      list: `${root}/rangeSoundSet/list`,
      delete: `${root}/rangeSoundSet/delete`,
      batchDelete: `${root}/rangeSoundSet/batchDelete`,
      add: `${root}/rangeSoundSet/add`,
      update: `${root}/rangeSoundSet/update`,
      detail: `${root}/rangeSoundSet/detail`,
    },

    recordModel: {
      list: `${root}/recordModel/list`,
      delete: `${root}/recordModel/delete`,
      batchDelete: `${root}/recordModel/batchDelete`,
      add: `${root}/recordModel/add`,
      update: `${root}/recordModel/update`,
    },

    weightCorrectSort: {
      list: `${root}/weightCorrectSort/list`,
      delete: `${root}/weightCorrectSort/delete`,
      batchDelete: `${root}/weightCorrectSort/batchDelete`,
      add: `${root}/weightCorrectSort/add`,
      update: `${root}/weightCorrectSort/update`,
    },

    intellectUnit: {
      list: `${root}/intellectUnit/list`,
      delete: `${root}/intellectUnit/delete`,
      batchDelete: `${root}/intellectUnit/batchDelete`,
      add: `${root}/intellectUnit/add`,
      update: `${root}/intellectUnit/update`,
      detail: `${root}/intellectUnit/detail`,
    },

    areaLanguageSet: {
      list: `${root}/areaLanguageSet/list`,
      delete: `${root}/areaLanguageSet/delete`,
      batchDelete: `${root}/areaLanguageSet/batchDelete`,
      add: `${root}/areaLanguageSet/add`,
      update: `${root}/areaLanguageSet/update`,
      detail: `${root}/areaLanguageSet/detail`,
    },

    lonLatCorrectSort: {
      list: `${root}/lonLatCorrectSort/list`,
      delete: `${root}/lonLatCorrectSort/delete`,
      batchDelete: `${root}/lonLatCorrectSort/batchDelete`,
      save: `${root}/lonLatCorrectSort/save`,
      listFirst: `${root}/lonLatCorrectSort/listFirst`,

    },

    data: {
      dataCenter: `${root}/data/dataCenter`,
      smartUnitCountList: `${root}/smartUnitCount/list`,
      multiunitWeighCountList: `${root}/multiunitWeighCount/list`,
      valuationModeCount: `${root}/valuationModeCount/list`,
      weighModeCount: `${root}/weighModeCount/list`,
      sectionModeCount: `${root}/sectionModeCount/list`,
      momentPowerModeCount: `${root}/momentPowerModeCount/list`,
      photoModeCount: `${root}/photoModeCount/list`,
      medicineModeCount: `${root}/medicineModeCount/list`,
      expressModeCount: `${root}/expressModeCount/list`,
      totalWeighCount: `${root}/totalWeighCount/list`,
      countModeCount: `${root}/countModeCount/list`,
      smartWeighCount: `${root}/smartWeighCount/list`,
      hardwareTestCount: `${root}/hardwareTestCount/list`,
      lonLatCorrectCount: `${root}/lonLatCorrectCount/list`,
      precisionAdjustCount: `${root}/precisionAdjustCount/list`,
      multiunitWeighCount: `${root}/multiunitWeighCount/list`,
    },

    lonLatCorrectRecord: {
      list: `${root}/lonLatCorrectRecord/list`,
      delete: `${root}/lonLatCorrectRecord/delete`,
      batchDelete: `${root}/lonLatCorrectRecord/batchDelete`,
      save: `${root}/lonLatCorrectRecord/save`,
    },

    userAuth: {
      list: `${root}/userAuth/list`,
      delete: `${root}/userAuth/delete`,
      batchDelete: `${root}/userAuth/batchDelete`,
      detail: `${root}/userAuth/detail`,
      updateStatus: `${root}/userAuth/updateStatus`,
      batchUpdateStatus: `${root}/userAuth/batchUpdateStatus`,
    },

    anOrder: {
      list: `${root}/anOrder/list`,
      listCbIn: `${root}/anOrder/listCbIn`,
      listMy: `${root}/anOrder/listMy`,
    },

    boiledRiceRecord: {
      list: `${root}/boiledRiceRecord/list`
    },

    cookToolCollect: {
      list: `${root}/cookToolCollect/list`,
      countData: `${root}/cookToolCollect/countData`,
    },

    foodCollect: {
      list: `${root}/foodCollect/list`
    },

    nutritionRecord: {
      listMy: `${root}/nutritionRecord/listMy`
    },

    withdrawAudit: {
      list: `${root}/withdrawAudit/list`,
      updateStatus: `${root}/withdrawAudit/updateStatus`,
    },

    recommendCalorie: {
      list: `${root}/recommendCalorie/listAll`,
      detail: `${root}/recommendCalorie/detail`,
      edit: `${root}/recommendCalorie/edit`,
    },

    mac: {
      list: `${root}/mac/list`,
      update: `${root}/mac/update`,
      importData: `${root}/mac/importData`,
    },

    logInfo: {
      list: `${root}/logInfo/list`,
      delete: `${root}/logInfo/delete`,
      batchDelete: `${root}/logInfo/batchDelete`,
    },
    exportData: {
      precisionAdjustCount: `${root}/precisionAdjustCount/exportData`,
      lonLatCorrectCount: `${root}/lonLatCorrectCount/exportData`,
      hardwareTestCount: `${root}/hardwareTestCount/exportData`,
      smartWeighCount: `${root}/smartWeighCount/exportData`,
      countModeCount: `${root}/countModeCount/exportData`,
      totalWeighCount: `${root}/totalWeighCount/exportData`,
      expressModeCount: `${root}/expressModeCount/exportData`,
      medicineModeCount: `${root}/medicineModeCount/exportData`,
      smartUnitCount: `${root}/smartUnitCount/exportData`,
      photoModeCount: `${root}/photoModeCount/exportData`,
      momentPowerModeCount: `${root}/momentPowerModeCount/exportData`,
      sectionModeCount: `${root}/sectionModeCount/exportData`,
      weighModeCount: `${root}/weighModeCount/exportData`,
      valuationModeCount: `${root}/valuationModeCount/exportData`,
      multiunitWeighCount: `${root}/multiunitWeighCount/exportData`,
      userVipRecord: `${root}/userVipRecord/exportData`,

    },

    linkHardwareRecord: {
      listUser: `${root}/linkHardwareRecord/listUser`
    },

    areaData: {
      list: `${root}/areaData/list`,
      add: `${root}/areaData/add`,
      delete: `${root}/areaData/delete`,
      batchDelete: `${root}/areaData/batchDelete`,
      update: `${root}/areaData/update`,
      findByUser: `${root}/areaData/findByUser`,
    },

    useArea: {
      list: `${root}/useArea/list`,
      add: `${root}/useArea/add`,
      delete: `${root}/useArea/delete`,
      batchDelete: `${root}/useArea/batchDelete`,
      update: `${root}/useArea/update`,
      updateStatus: `${root}/useArea/updateStatus`,
      updateDefault: `${root}/useArea/updateDefault`,
    },

    sysUser: {
      list: `${root}/sysUser/list`,
      add: `${root}/sysUser/add`,
      delete: `${root}/sysUser/delete`,
      batchDelete: `${root}/sysUser/batchDelete`,
      update: `${root}/sysUser/update`,
      detail: `${root}/sysUser/detail`,
    },
    intellectHardware: {
      list: `${root}/intellectHardware/list`,
      add: `${root}/intellectHardware/add`,
      update: `${root}/intellectHardware/update`,
      detail: `${root}/intellectHardware/detail`,
      exportData: `${root}/intellectHardware/exportData `,
      delete: `${root}/intellectHardware/delete `,
    },

    payFee: {
      list: `${root}/payFee/list`,
      add: `${root}/payFee/add`,
      update: `${root}/payFee/update`,
      detail: `${root}/payFee/detail`,
      exportData: `${root}/payFee/exportData `,
      delete: `${root}/payFee/delete `,
    },

    elFlag: {
      list: `${root}/elFlag/list`,
      add: `${root}/elFlag/add`,
      update: `${root}/elFlag/update`,
      detail: `${root}/elFlag/detail`,
    },

    recommend: {
      list: `${root}/recommend/list`,
      add: `${root}/recommend/add`,
      update: `${root}/recommend/update`,
      detail: `${root}/recommend/detail`,
      delete: `${root}/recommend/delete`,
      batchDelete: `${root}/recommend/batchDelete`,
    },

    labor: {
      list: `${root}/labor/list`,
      add: `${root}/labor/add`,
      update: `${root}/labor/update`,
      detail: `${root}/labor/detail`,
      delete: `${root}/labor/delete`,
      batchDelete: `${root}/labor/batchDelete`,
    },

    bmi: {
      list: `${root}/bmi/list`,
      add: `${root}/bmi/add`,
      update: `${root}/bmi/update`,
      detail: `${root}/bmi/detail`,
      delete: `${root}/bmi/delete`,
      batchDelete: `${root}/bmi/batchDelete`,
    },

    nutriRecommend: {
      list: `${root}/nutriRecommend/list`,
      save: `${root}/nutriRecommend/save`,
      delete: `${root}/nutriRecommend/delete`,
      batchDelete: `${root}/nutriRecommend/batchDelete`,
      batchAdd: `${root}/nutriRecommend/batchAdd`,
      update: `${root}/nutriRecommend/update`,
    },

    algo: {
      list: `${root}/algo/list`,
      add: `${root}/algo/add`,
      update: `${root}/algo/update`,
      detail: `${root}/algo/detail`,
      delete: `${root}/algo/delete`,
      batchDelete: `${root}/algo/batchDelete`,
    },

    region: {
      tree: `${root}/region/tree`,
      save: `${root}/region/save`,
      add: `${root}/region/add`,
      update: `${root}/region/update`,
      delete: `${root}/region/delete`,
      batchDelete: `${root}/region/batchDelete`,
    },

    geo: {
      list: `${root}/geo/list`,
      add: `${root}/geo/add`,
      update: `${root}/geo/update`,
      delete: `${root}/geo/delete`,
      batchDelete: `${root}/geo/batchDelete`,
    }

  },
  api
)
